import { Helmet } from "react-helmet-async";

const Seo = ({ title, description, noindex = false, faq = null }) => (
  <Helmet>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    {noindex && <meta name="robots" content="noindex, nofollow" />}
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    <meta name="twitter:title" content={title} />
    {description && <meta name="twitter:description" content={description} />}
    {faq && (
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faq.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        })}
      </script>
    )}
  </Helmet>
);

export default Seo;
